module.exports = __webpack_public_path__ + "static/media/KoLab.d5e85613.png";